import React, { useEffect, useState } from "react";
import {
    Box,
    TextField,
    Button,
    MenuItem,
    FormControlLabel,
    Switch,
    Grid2,
} from "@mui/material";
import Navbar from "../../setup/Navbar";
import HeadingText from '../../../BuiltInComponent/HeadingTest'
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addNewBranch, getBranchData } from "../../../features/AdminManagement/branchSlice";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import dayjs from "dayjs";

export default function BranchesForm() {

    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if (location.state?.branchID) {
            dispatch(getBranchData({ branchID: location.state?.branchID })).then((res) => {
                setFormData((prev) => ({
                    ...prev,
                    branchID: location.state?.branchID || null,
                    entDate: dayjs(res.payload.entDate).format('YYYY-MM-DD'),
                    branchName: res.payload.branchName,
                    branchOwnerName: res.payload.branchOwnerName,
                    branchAddress: res.payload.branchAddress,
                    branchContactNo: res.payload.branchContactNo,
                    branchCategory: res.payload.branchCategory,
                    remarks: res.payload.remarks,
                    branchStatus: res.payload.branchStatus,
                    delivery_printer_ip: res.payload.delivery_printer_ip || "",
                    delivery_printer_port: res.payload.delivery_printer_port || "",
                }))
            })
        }
    }, [dispatch, location.state?.branchID])

    const [formData, setFormData] = useState({
        branchID: location.state?.branchID || null,
        entDate: "",
        branchName: "",
        branchOwnerName: "",
        branchAddress: "",
        branchContactNo: "",
        branchCategory: "Cloud Kitchen",
        remarks: "",
        branchStatus: true,
        delivery_printer_ip: "",
        delivery_printer_port: "",
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(addNewBranch(formData)).then(() => {
            navigate('/Branches')
        })
    };

    return (
        <>
            <Navbar />
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ maxWidth: 800, mx: "auto", p: 3, borderRadius: 2 }}
            >
                <Grid2 container spacing={2}>
                    <Grid2 size={12}>
                        <KeyboardBackspaceIcon
                            sx={{
                                fontSize: 30, marginLeft: -1, color: 'white', cursor: 'pointer',
                                backgroundColor: '#1D4988', padding: 1, borderRadius: 50
                            }}
                            onClick={() => { navigate('/Branches') }} />

                    </Grid2>
                    <Grid2 size={12}>
                        <HeadingText text={'Add New Branch'} />
                    </Grid2>
                    <Grid2 size={4}>
                        <TextField
                            label="Entry Date"
                            type="date"
                            name="entDate"
                            value={formData.entDate}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid2>
                    <Grid2 size={8}>
                        <TextField
                            label="Branch Name"
                            name="branchName"
                            value={formData.branchName}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            required
                        />
                    </Grid2>
                    <Grid2 size={6}>

                        <TextField
                            label="Owner Name"
                            name="branchOwnerName"
                            value={formData.branchOwnerName}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField
                            label="Address"
                            name="branchAddress"
                            value={formData.branchAddress}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            multiline
                            rows={2}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <TextField
                            label="Contact No"
                            name="branchContactNo"
                            value={formData.branchContactNo}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <TextField
                            select
                            label="Category"
                            name="branchCategory"
                            value={formData.branchCategory}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        >
                            <MenuItem value="Cloud Kitchen">Cloud Kitchen</MenuItem>
                            <MenuItem value="Branch">Branch</MenuItem>
                        </TextField>
                    </Grid2>
                    <Grid2 size={6}>
                        <TextField
                            label="Delivery Printer IP"
                            name="delivery_printer_ip"
                            value={formData.delivery_printer_ip}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            placeholder="192.168.10.121"
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <TextField
                            label="Delivery Printer Port"
                            name="delivery_printer_port"
                            value={formData.delivery_printer_port}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            type="number"
                            placeholder="9100"
                        />
                    </Grid2>
                    <Grid2 size={8}>
                        <TextField
                            label="Remarks"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            multiline
                            rows={2}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.branchStatus}
                                    onChange={(e) =>
                                        setFormData({ ...formData, branchStatus: e.target.checked })
                                    }
                                    name="branchStatus"
                                />
                            }
                            label="Active Status"
                        />
                    </Grid2>
                    <Grid2 size={4}>
                    </Grid2>
                    <Grid2 size={4}>
                        <Button type="submit" variant="contained" color="primary" fullWidth>
                            Save Branch
                        </Button>
                    </Grid2>
                    <Grid2 size={4}>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    );
};

